const MenuBottomIcon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="14" height="14" viewBox="0 0 14 14"
		{...props}
	>
		<rect x="2" y="2" width="10" height="10" stroke="CurrentColor" fill="none" strokeWidth="2" />
		<rect x="4" y="8" width="6" height="2" fill="CurrentColor" />
	</svg>
)

export default MenuBottomIcon